import { render, staticRenderFns } from "./faceManage.vue?vue&type=template&id=1cb9d758&scoped=true&"
import script from "./faceManage.vue?vue&type=script&lang=js&"
export * from "./faceManage.vue?vue&type=script&lang=js&"
import style0 from "./faceManage.vue?vue&type=style&index=0&id=1cb9d758&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cb9d758",
  null
  
)

export default component.exports